import { render } from "./productsModal.vue?vue&type=template&id=db9c8b6c&ts=true"
import script from "./productsModal.vue?vue&type=script&lang=ts"
export * from "./productsModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__